import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Checkbox } from 'zens-storybook'

import { Activity } from './timeline'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  filter?: Activity[]
  onChangeFilter?: (filter: Activity[]) => void
}

const ActivityFilter = (props: Props) => {
  const { filter = [], onChangeFilter, style, ...otherProps } = props
  const { t } = useTranslation()

  function updateFilter(keys: Activity[]) {
    return (value: boolean) => {
      onChangeFilter?.([...filter.filter((activity) => keys.indexOf(activity) < 0), ...(value ? keys : [])])
    }
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Checkbox
        value={filter.indexOf('sync') >= 0}
        label={t('Synchronization')}
        onValueChange={updateFilter(['sync'])}
        testID="ActivityFilter.Sync"
      />
      <Checkbox
        value={filter.indexOf('firmware') >= 0}
        label={t('Firmware version')}
        onValueChange={updateFilter(['firmware'])}
        testID="ActivityFilter.Firmware"
      />
      <Checkbox
        value={filter.indexOf('occupied') >= 0}
        label={t('Occupancy')}
        onValueChange={updateFilter(['occupied', 'charging', 'occupied_charging', 'available'])}
        testID="ActivityFilter.Occupied"
      />
      <Checkbox
        value={filter.indexOf('pdp_cycle') >= 0}
        label={t('PDP cycle')}
        onValueChange={updateFilter(['pdp_cycle'])}
        testID="ActivityFilter.PdpCycle"
      />
      <Checkbox
        value={filter.indexOf('power_cycle') >= 0}
        label={t('Power cycle')}
        onValueChange={updateFilter(['power_cycle'])}
        testID="ActivityFilter.PowerCycle"
      />
      <Checkbox
        value={filter.indexOf('incomplete') >= 0}
        label={t('Product incomplete')}
        onValueChange={updateFilter(['incomplete'])}
        testID="ActivityFilter.Incomplete"
      />
      <Checkbox
        value={filter.indexOf('unknown') >= 0}
        label={t('Repeated occupancy')}
        onValueChange={updateFilter(['unknown'])}
        testID="ActivityFilter.Unknown"
      />
      <Checkbox
        value={filter.indexOf('csq') >= 0}
        label={t('Signal quality')}
        onValueChange={updateFilter(['csq'])}
        testID="ActivityFilter.Csq"
      />
    </View>
  )
}

interface SkeletonProps extends ViewProps {}

function Skeleton(props: SkeletonProps) {
  const { style } = props
  const { t } = useTranslation()

  return (
    <View style={[styles.container, style]}>
      <Checkbox label={t('Synchronization')} />
      <Checkbox label={t('Firmware version')} />
      <Checkbox label={t('Occupancy')} />
      <Checkbox label={t('PDP cycle')} />
      <Checkbox label={t('Power cycle')} />
      <Checkbox label={t('Product incomplete')} />
      <Checkbox label={t('Repeated occupancy')} />
    </View>
  )
}
ActivityFilter.Skeleton = Skeleton

export default ActivityFilter
